<template>
	<section v-closable="close" :class="[ 'sk-card', { 'sk-card--has-header': header, 'sk-card--open': isOpen }, iconClass]">
		<a v-if="hasMoreOptions" class="sk-card__header-options" @click="onToggle_ClickHandler"></a>
		<header class="sk-card__header" v-if="header">
			<div class="sk-card__header-title">{{ title }}</div>
		</header>
		<main class="sk-card__content">
			<slot></slot>
		</main>
		<div v-if="hasMoreOptions" class="sk-card__more-options">
			<div>
				<h1 class="more-options-title">{{ title }}</h1>
				<slot name="more-options"></slot>
			</div>
		</div>
	</section>
</template>

<script>
import Closable from '@/directives/Closable'
export default {
	name: 'card',
	props: {
		header: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: null
		}
	},
	directives: {
		Closable
	},
	data() {
		return {
			isOpen: false,
			icons: [
				"heart-rate",
				"blood-pressure",
				"blood-saturation",
				"calories",
				"pedometer",
				"temperature",
				"fall"
			]
		}
	},
	methods: {
		onToggle_ClickHandler() {
			this.isOpen = !this.isOpen
		},
		close() {
			this.isOpen = false
		}
	},
	computed: {
		hasMoreOptions() {
			return !!this.$slots['more-options']
		},
		hasIcon() {
			return this.icon != null && this.icons.includes(this.icon)
		},
		iconClass() {
			if (!this.hasIcon)
				return ''
			return `icon-${this.icon}`
		}
	},
	created() {
		this.$on('close', this.close)
	},
	destroyed() {
		this.$off('close', this.close)
	}
}
</script>

<style scope>
.sk-card {
	background-color: #fff;
	box-shadow: rgba(0,0,0,0.1) 1px 1px 5px;
	border-radius: 5px;
	position: relative;
	overflow: hidden;
}
.sk-card::after,
.sk-card::before {
	content: ' ';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-position: center 60px;
	background-size: auto 175px;
	opacity: 0.1;
	z-index: 1;
}
.sk-card.icon-heart-rate::before {
	background-image: url(/static/svg/readings/heartbeat.svg);
}
.sk-card.icon-blood-pressure::before {
	background-image: url(/static/svg/readings/bloodpressure.svg);
}
.sk-card.icon-blood-saturation::before {
	background-image: url(/static/svg/readings/bloodsaturation.svg);
}
.sk-card.icon-calories::before {
	width: 50%;
	background-image: url(/static/svg/readings/pedometer.svg);
	background-position: center;
	background-size: auto 165px;
}
.sk-card.icon-calories::after {
	width: 50%;
	left: 50%;
	background-position: center;
	background-image: url(/static/svg/readings/calories.svg);
}
.sk-card.icon-pedometer::before {
	background-image: url(/static/svg/readings/pedometer.svg);
}
.sk-card.icon-temperature::before {

	background-image: url(/static/svg/readings/temperature.svg);
}
.sk-card.icon-fall::before {
	background-image: url(/static/svg/readings/fall.svg);
}

.sk-card--has-header {
	display: grid;
	grid-template-rows: 40px 1fr;
}

.sk-card__header {
	display: grid;
	grid-template-columns: 1fr 40px;
	align-items: center;
	z-index: 2;
}

.sk-card__header-title {
	padding: 0 20px;
	font-weight: 700;
	font-size: 13px;
	color: #aaa;
}

.sk-card__header-options {
	position: absolute;
	right: 0;
	top: 0;
	display: block;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	color: #aaa;
	text-decoration: none;
	background-image: url(/static/svg/buttons/show-more-button-with-three-dots.svg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 15px 15px;
	cursor: pointer;
	z-index: 11;
}

.sk-card__header-options:hover,
.sk-card__header-options:active {
	background-color: rgba(0,0,0,0.05);
}

.sk-card__content {
	height: 100%;
	width: 100%;
	overflow: hidden;
	z-index: 2;
}
.sk-card__more-options {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	clip-path: circle(0% at 100% 0);
	transition: clip-path 0.3s;
	background-color: var(--main-color);
	z-index: 10;
}
.more-options-title {
	position: absolute;
	top: 10px;
	color: rgba(255,255,255,0.5);
	font-size: 12px;
	text-transform: uppercase;
}
.sk-card__more-options > div {
	transform: translate(0, 100px);
	opacity: 0;
	transition: all 1s 0.2s;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 50px;
}
.sk-card__more-options > div > a,
.sk-card__more-options > div > button {
	padding: 10px;
	border-top: 0;
	border-left: 0;
	border-right: 0;
	border-bottom: rgba(255, 255, 255, 0.1) solid 1px;
	background: transparent;
	color: #fff;
	font-size: 16px;
	width: 100%;
	box-sizing: border-box;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
}

.sk-card__more-options > div > a:last-child,
.sk-card__more-options > div > button:last-child {
	border-bottom: 0;
}
.sk-card__more-options > div > a > span,
.sk-card__more-options > div > button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
}
.sk-card__more-options > div > a:hover > span,
.sk-card__more-options > div > button:hover > span {
	transform: translate(5px, 0);
	font-weight: 700;
}

.sk-card.sk-card--open .sk-card__more-options {
	transition: clip-path 1s;
	clip-path: circle(200% at 100% 0);
}
.sk-card.sk-card--open .sk-card__more-options > div {
	transform: translate(0, 0);
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/Card.vue